import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { formatDate } from '@angular/common';
import { LocalStorageService } from 'ngx-webstorage';
import { MedicalHistoryModel } from 'src/app/models/MedicalHistoryModel';
import { MedicalHistoryService } from 'src/app/services/MedicalHistoryService';

@Component({
  selector: 'app-medical-history-v',
  templateUrl: './medical-history-v.component.html',
  styleUrls: ['./medical-history-v.component.css']
})
export class MedicalHistoryVComponent implements OnInit {
  diabetescheck = false;
  diabetes = '' ;
  diabetessince = 0 ;
  diabetesdays = '' ;
  diabetescontrol = '' ;
  haypercheck = false;
  hayper = '' ;
  haypersince = 0 ;
  hayperdays = '' ;
  haypercontrol = '' ;
  hepacheck = false;
  hepa = '' ;
  hepasince = 0 ;
  hepadays = '' ;
  hepacontrol = '' ;
  bilhcheck =false;
  bilh = '' ;
  bilhsince = 0 ;
  bilhdays = '' ;
  bilhcontrol = '' ;
  cardcheck = false;
  card = '' ;
  cardsince = 0 ;
  carddays = '' ;
  cardcontrol = '' ;
  auto = '' ;
  autosince = 0 ;
  autodays = '' ;
  autocontrol = '' ;
  allergy = '' ;
  allergysince = 0 ;
  allergydays = '' ;
  allergycontrol = '' ;
  othersM = '' ;
  othersMcheck = false;
  otherssince = 0 ;
  othersdays = '' ;
  otherscontrol = '' ;

  MHColor =  'rgb(3, 0, 98)';
  MHColor1 = 'rgb(3, 0, 98)';
  MHColor2 = 'rgb(3, 0, 98)';
  MHColor3 = 'rgb(3, 0, 98)';
  MHColor4 = 'rgb(3, 0, 98)';
  MHColor5 = 'rgb(3, 0, 98)';
  MHColor6 = 'rgb(3, 0, 98)';
  MHColor7 = 'rgb(3, 0, 98)';
  constructor(public medicalhistoryService : MedicalHistoryService,
              public medicalhistory : MedicalHistoryModel,
    public storage: LocalStorageService,
  ) { }
  Patientcode = '';
  Patientname = '';
  visitdate  = '';



  ngOnInit(): void {
        this.Patientcode = this.storage.retrieve('stgPatientCode');
        this.Patientname = this.storage.retrieve('stgPatientName');
        this.visitdate =   formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
        this.retriveMedicalHistory();
  }
/////////////======= Medical History Data ========////////
   retriveMedicalHistory() {
    this.medicalhistoryService.getMHistory(this.Patientcode, this.storage.retrieve('stgcompCode')).subscribe({
          next: (data: MedicalHistoryModel) => {
            if(data.diabetes == 'True'){this.diabetescheck = true}else{this.diabetescheck = false}
            this.diabetessince = data.diabetessince ;

            this.diabetesdays = data.diabetesdays;
            if (this.diabetesdays == null){this.diabetesdays = ''}
            this.diabetescontrol = data.diabetescontrol ;
            if(data.hayper == 'True'){this.haypercheck = true}else{this.haypercheck = false}

            this.haypersince = data.haypersince ;

            this.hayperdays = data.hayperdays;
            if (this.hayperdays == null){this.hayperdays = ''}
            this.haypercontrol = data.haypercontrol;

            if(data.hepa == 'True'){this.hepacheck = true}else{this.hepacheck = false}
            this.hepasince = data.hepasince ;

            this.hepadays = data.hepadays ;
            if (this.hepadays == null){this.hepadays = ''}
            this.hepacontrol = data.hepacontrol;

            if(data.bilh.toString() == 'True'){this.bilhcheck = true}else{this.bilhcheck = false}
            this.bilhsince = data.bilhsince;
            this.bilhdays = data.bilhdays;
            if (this.bilhdays == null){this.bilhdays = ''}


            this.bilhcontrol = data.bilhcontrol ;
            if(data.card.toString() == 'True'){this.cardcheck = true}else{this.cardcheck = false}
            this.cardsince = data.cardsince ;
            this.carddays = data.carddays ;
            this.cardcontrol = data.cardcontrol ;
            this.auto = 'False' ;
            this.autosince = data.autosince ;
            this.autodays = data.autodays ;
            this.autocontrol = data.autocontrol ;
            this.allergy = data.allergy ;
            this.allergysince = data.allergysince ;
            this.allergydays = data.allergydays ;
            this.allergycontrol = data.allergycontrol ;
            if(data.others == 'True'){this.othersMcheck = true}else{this.othersMcheck = false}
            this.othersM = data.others ;
            this.otherssince = data.otherssince ;
            this.othersdays = data.othersdays ;
            this.otherscontrol = data.otherscontrol;

          },
          error: (error) => {
            // Handle any actual errors here, if needed.  For example:
            console.error("Error fetching nurse assessment:", error);
            // You might also want to display an error message to the user.
          },
          complete: () => {
            // This block executes after a successful completion (even if data is null/undefined).
              if (!this.diabetesdays) {  // Check if visitlocation is undefined or null.  Could also check for an empty string "" if that's a possibility.
              //  this.diabetescheck = false;
               }
          }
        });


  }
  Save_MedicalHistory(){

      this.medicalhistory.patientcode = this.Patientcode ;
      if(this.diabetescheck == true){this.medicalhistory.diabetes = 'True'}else{this.medicalhistory.diabetes = 'False'} ;
      this.medicalhistory.diabetessince = this.diabetessince ;
      this.medicalhistory.diabetesdays = this.diabetesdays ;
      this.medicalhistory.diabetescontrol = '' ;
      if(this.haypercheck == true){this.medicalhistory.hayper = 'True'}else{this.medicalhistory.hayper = 'False'} ;
      this.medicalhistory.haypersince = this.haypersince ;
      this.medicalhistory.hayperdays = this.hayperdays ;
      this.medicalhistory.haypercontrol = '';
      if(this.hepacheck == true){this.medicalhistory.hepa = 'True'}else{this.medicalhistory.hepa = 'False'} ;
      this.medicalhistory.hepasince = this.hepasince ;
      this.medicalhistory.hepadays = this.hepadays ;
      this.medicalhistory.hepacontrol = '' ;
      if(this.bilhcheck == true){this.medicalhistory.bilh = 'True'}else{this.medicalhistory.bilh = 'False'} ;
      this.medicalhistory.bilhsince = this.bilhsince ;
      this.medicalhistory.bilhdays = this.bilhdays ;
      this.medicalhistory.bilhcontrol = '' ;
      if(this.cardcheck == true){this.medicalhistory.card = 'True'}else{this.medicalhistory.card = 'False'} ;
      this.medicalhistory.cardsince = this.cardsince ;
      this.medicalhistory.carddays = this.carddays ;
      this.medicalhistory.cardcontrol = '' ;
      this.medicalhistory.auto = 'False' ;
      this.medicalhistory.autosince = this.autosince ;
      this.medicalhistory.autodays = this.autodays ;
      this.medicalhistory.autocontrol = '' ;
      this.medicalhistory.allergy = 'False' ;
      this.medicalhistory.allergysince = this.allergysince ;
      this.medicalhistory.allergydays = this.allergydays ;
      this.medicalhistory.allergycontrol = '' ;
      if(this.othersMcheck == true){this.medicalhistory.others = 'True'}else{this.medicalhistory.others = 'False'} ;
      this.medicalhistory.otherssince = this.otherssince ;
      this.medicalhistory.othersdays = this.othersdays ;
      this.medicalhistory.otherscontrol = this.otherscontrol ;
      this.medicalhistory.userid = this.storage.retrieve('stguserId');
      this.medicalhistory.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.medicalhistory.compcode = this.storage.retrieve('stgcompCode');
      this.medicalhistoryService.AddMHistory(this.medicalhistory).subscribe(data => {

     // this.mesgSave();

    },

      error => { alert(error); console.log("Diom");}

    );

  }
}
